import {Injectable} from '@angular/core';
import {AppConfig} from 'appConfig';
import {getUrlRelativeToPublicPath} from '../common/public-path';
import appConfig from '../config/app-config';
import {ApiConfig} from './api-config.service';

export const isDevEnv = (env: string): boolean => {
    return /\bdev\b/.test(env);
};

export const isDevOrCiEnv = (env: string): boolean => {
    return /\bci|dev\b/.test(env);
};

export const isBoEnv = (env: string): boolean => {
    return /\bbo|backoffice\b/.test(env);
};

@Injectable()
export class AppConfigService {

    public api: ApiConfig;
    public appConfig: AppConfig;

    constructor() {
        let config: AppConfig = appConfig || {} as AppConfig;

        config = {
            ...config,
            api: new ApiConfig(config.api)
        };

        this.appConfig = config;
        this.api = config.api as ApiConfig;
    }

    public getPublicPath(url?: string): string {
        const publicPath: string = this.appConfig.publicPath;

        return getUrlRelativeToPublicPath(url, publicPath);
    }

    public isDevEnv(): boolean {
        return isDevEnv(this.appConfig.env);
    }

    public isDevOrCiEnv(): boolean {
        return isDevOrCiEnv(this.appConfig.env);
    }

    public isBoEnv(): boolean {
        return this.appConfig.isBackoffice || isBoEnv(this.appConfig.env);
    }
}
